import { Link } from 'react-router-dom';
import Counter from '@/components/base/Counter';
import Reveal from '@/components/base/Reveal';
import { heroStats } from '@/mocks/strategix';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -left-32 w-[560px] h-[560px] rounded-full bg-primary-500/20 blur-[150px]"></div>
        <div className="absolute -top-20 right-0 w-[480px] h-[480px] rounded-full bg-accent-500/15 blur-[160px]"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[720px] h-[520px] rounded-full bg-primary-800/15 blur-[160px]"></div>
      </div>

      <div className="relative w-full px-5 md:px-10">
        <div className="max-w-6xl mx-auto py-20 md:py-28 text-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary-400/50 bg-primary-500/10 text-xs md:text-sm text-foreground-800">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              Агентство по продвижению сообществ, сайтов и каналов
            </span>
          </Reveal>

          <Reveal delay={100}>
            <h1 className="mt-7 font-heading font-extrabold uppercase text-3xl sm:text-4xl md:text-6xl leading-[1.08] tracking-tight text-foreground-950 max-w-4xl mx-auto">
              Продвижение сообществ, сайтов и каналов{' '}
              <span className="text-gold-gradient">с гарантией результата</span>
            </h1>
          </Reveal>

          <Reveal delay={200}>
            <p className="mt-6 text-sm md:text-lg text-foreground-700 max-w-2xl mx-auto leading-relaxed">
              Настраиваем таргет, упаковываем сообщества и сайты, растим охваты. Вы видите каждый рубль рекламного
              бюджета и каждую заявку — в понятной отчётности без сложных терминов.
            </p>
          </Reveal>

          <Reveal delay={300}>
            <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/pricing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-300 text-foreground-900 text-sm font-semibold hover:border-primary-400 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                Смотреть тарифы
              </Link>
            </div>
          </Reveal>

          <Reveal delay={400}>
            <p className="mt-6 text-xs md:text-sm text-foreground-600">
              Работаем по договору · Отчётность каждую неделю · Доступы остаются у вас
            </p>
          </Reveal>

          <div className="mt-16 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px rounded-lg overflow-hidden border border-background-200/70 bg-background-200/70">
            {heroStats.map((stat, index) => (
              <Reveal key={stat.label} delay={index * 90} className="h-full">
                <div className="h-full bg-background-100/80 px-5 py-7 md:py-9 text-center">
                  <p className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
                    <Counter value={stat.value} suffix={stat.suffix} />
                  </p>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600">{stat.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}